module.exports = __webpack_public_path__ + "img/copyright.d0289dc0.png";